// extracted by css-extract-rspack-plugin
export default {"recentModelsGrid":"_s_EN"};